import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="canvas" title="Frequently asked questions" cta="Yes, I'm ready for a structured workflow" ctaNote="One-Time Payment of $27 USD · Instant Download · 7-Day Guarantee" data-id="element-105" data-mp="1cehx9lltda1c">
      <div className="mx-auto max-w-3xl divide-y divide-line rounded-3xl bg-white px-5 shadow-card sm:px-8" data-id="element-106" data-mp="252m9kpyw4ld0">
        {faqs.map((faq, i) => {
        const isOpen = open === i;
        return <div key={faq.q} data-id="element-107" data-mp="1v5hkah9r09rz" data-mpi={i}>
              <h3 data-id="element-108" data-mp="1v46igmzv5c3i">
                <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[17px] font-bold leading-snug text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-109" data-mp="1v72e24o8noos">
                  <span data-id="element-110" data-mp="1pmb9yry8sreq">{faq.q}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-brand text-white' : 'bg-brand-soft text-brand'}`} data-id="element-111" data-mp="1apkhl2mzkfym">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-112" data-mp="16ogzsaldo9ur" />
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-113" data-mp="s0ma732o2llw">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-114" data-mp="wz79n0a3h19a">
                    <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-115" data-mp="2pogdtiinssbb">{faq.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}